import React from 'react';
import Remarkable from 'remarkable'

const md = new Remarkable({
    html: true
});

const Markdown = (props) => {
    return (
        <div className="rich-text content-box" dangerouslySetInnerHTML={{__html: md.render(props.source) }}></div>
    )
};

export default Markdown;


// WEBPACK FOOTER //
// ./app/components/shared/Markdown.jsx